export default __webpack_public_path__ + "static/media/Mark-3-Suit-Cycles-03.11ef6d09.jpg";